import React from 'react'

const CustomerRefundPolicy = () => {
    return (
        <div>CustomerRefundPolicy</div>
    )
}

export default CustomerRefundPolicy